import React from "react";
import styled from "styled-components";
import AddIconSrc from "../../../../../images/icons/add-icon.svg";
import TabContent from "../../../Components/Main/Sidebar/TabContent";
import MenuButton from "../../../Components/Main/Sidebar/MenuButton";
import TabContentLoading from "../../../Components/Main/Sidebar/TabContentLoading";
import AddIcon from "../../../Components/Main/Sidebar/AddIcon";
import MenuSearchInput from "../../../Components/Main/Sidebar/MenuSearchInput";
import ModalOption from "../../../Components/Main/Modals/ModalOption";
import MenuSelect from "../../../Components/Main/Modals/MenuSelect";
import api from "../../../../util/api";

import ThreeDotMenuIcon from "../../../../../images/icons/3-dot-menu-icon.png";

const Wrapper = styled.section`
    display: ${(props) => (props.open ? "block" : "none")};
    background: white;
`;

const SortWrapper = styled.div`overflow: auto; width: 100%;`;
const SortLabel = styled.span`
    width: 35%; float: left; font-size: 18px; color: #737697; padding-top: 19px;
`;
const SortInputWrapper = styled.span`width: 65%; float: left;`;

const FilesList = styled.div``;
const FileRow = styled.div`
    border-bottom: 1px solid gray;
    padding: 21px;
    display: block;
    width: 100%;
    color: black;
`;
const FileHeading = styled.h3`
    font-size: 18px;
    line-height: 21px;
    margin: 0;
    padding: 0;
    position: relative;
    padding-right: 25px;
    min-height: 45px;
`;
const FileName = styled.a`cursor: pointer; font-weight: 700;`;
const FileSubheading = styled.p`
    font-size: 12px; line-height: 17px; color: gray; margin-top: 6px; margin-bottom: 0;
`;

const ThreeDotMenuTrigger = styled.img`
    height: 18px; position: absolute; top: 0; right: 7px; cursor: pointer;
`;
const ThreeDotMenu = styled.div`
    position: absolute; top: 0; right: 0;
    background: white; border: 2px solid lightgrey; padding: 10px;
    box-shadow: 5px 5px 25px #0000002e; z-index: 9;
    display: ${(props) => (props.open ? "block" : "none")};
`;
const ThreeDotMenuClose = styled.div`
    position: absolute; top: 6px; right: 6px; cursor: pointer; color: grey;
`;
const ThreeDotMenuItem = styled.div`
    margin-bottom: 6px; border-bottom: 1px solid lightgrey;
    padding-bottom: 6px; width: 145px; cursor: pointer;
    ${(props) => (props.no_border ? "border: none !important; margin: 0 !important; padding: 0 !important;" : "")}
`;
const FontAwesomeIcon = styled.i`
    color: #515151; margin-right: 15px; top: 1px; position: relative; cursor: pointer;
`;

const PaginationResults = styled.div`
    color: #888888; font-size: 14px; text-align: center;
    border-top: 1px solid lightgrey; padding-top: 20px; padding-bottom: 5px; margin-top: -10px;
`;

export default class StudentFilesMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { three_dot_menu_open: null };
    }

    setThreeDotMenuOpen(val) {
        this.setState({ three_dot_menu_open: val });
    }

    renderSharing(file) {
        if (file.full_label && file.short_label && file.short_label !== file.user?.name) {
            return `Shared with ${file.full_label.split(',').slice(1).join(',').trim() || file.short_label}`;
        }
        return "Private";
    }

    render() {
        const files = this.props.yourFiles || {};

        return (
            <Wrapper open={this.props.open}>
                <TabContent open={true}>
                    <TabContentLoading open={this.props.filesLoading}>
                        <i className="fa fa-spinner"></i>
                    </TabContentLoading>

                    <MenuButton onClick={this.props.newFileAction}>
                        <AddIcon src={AddIconSrc} />
                        {"Add File"}
                    </MenuButton>

                    <MenuSearchInput
                        onKeyDown={this.props.searchMyFiles}
                        onChange={this.props.searchMyFiles}
                        placeholder="Search Files"
                    />

                    <SortWrapper>
                        <SortLabel>Sort By:</SortLabel>
                        <SortInputWrapper>
                            <MenuSelect onChange={(e) => { this.props.selectSort(e, 'myFiles'); }}>
                                <ModalOption value="created_at">Created Date</ModalOption>
                                <ModalOption value="name">Name</ModalOption>
                            </MenuSelect>
                        </SortInputWrapper>
                    </SortWrapper>

                    {this.props.paginationMeta ? (
                        <PaginationResults>
                            showing {Object.keys(files).length} of {this.props.paginationMeta.total} results
                        </PaginationResults>
                    ) : null}

                    <FilesList>
                        {Object.keys(files).map((key) => {
                            const file = files[key];
                            const menuOpen = this.state.three_dot_menu_open === file.id;
                            return (
                                <FileRow key={file.id}>
                                    <FileHeading>
                                        <FileName target="_blank" href={file.full_url}>{file.name}</FileName>
                                        <ThreeDotMenuTrigger
                                            onClick={() => this.setThreeDotMenuOpen(file.id)}
                                            src={ThreeDotMenuIcon}
                                        />
                                        <ThreeDotMenu open={menuOpen}>
                                            <ThreeDotMenuClose onClick={() => this.setThreeDotMenuOpen(null)}>X</ThreeDotMenuClose>
                                            <ThreeDotMenuItem onClick={(e) => {
                                                e.preventDefault();
                                                this.setThreeDotMenuOpen(null);
                                                this.props.shareFileAction(file.id);
                                            }}>
                                                <FontAwesomeIcon className="fas fa-share-square" />
                                                Share
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem no_border={true} onClick={(e) => {
                                                e.preventDefault();
                                                if (confirm("Are you sure you want to delete the File?")) {
                                                    api().delete('/files/' + file.id).then(() => {
                                                        this.setThreeDotMenuOpen(null);
                                                        this.props.pullFiles(false, this.props.paginationMeta?.current_page || 1);
                                                    });
                                                }
                                            }}>
                                                <FontAwesomeIcon className="fas fa-trash" />
                                                Delete
                                            </ThreeDotMenuItem>
                                        </ThreeDotMenu>
                                        <FileSubheading>
                                            {this.renderSharing(file)} — {file.created_at}
                                        </FileSubheading>
                                    </FileHeading>
                                </FileRow>
                            );
                        })}
                    </FilesList>
                </TabContent>
            </Wrapper>
        );
    }
}
